import { CircularProgress, Stack } from '@mui/material'

interface Props {
  label: string
}

export const ActionProgress = ({ label }: Props) => (
  <Stack direction="row" alignItems="center" gap={1} sx={{ height: '100%' }}>
    <CircularProgress size={16} color="secondary" />
    {label} ...
  </Stack>
)
